import React, {
  useEffect,
  useState,
  useLayoutEffect,
} from "react";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import CloseIcon from "@material-ui/icons/Close";
import { Box } from "@material-ui/core";
import ScheduleFor from "./ScheduleFor";
import Confetti from "images/confetti.png";
import * as constants from "Constants";
import {
  Modal,
  Button,
  Tooltip,
  IconButton,
  withStyles,
} from "@material-ui/core";
import "./UpdateAttendees.css";
import { makeStyles } from "@material-ui/core/styles";
import {
  EditorState,
  convertToRaw,
  convertFromHTML,
  ContentState,
} from "draft-js";

import { Info } from "@material-ui/icons";
import draftToHtml from "draftjs-to-html";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { IoCloseOutline } from "react-icons/io5";
import { axiosE } from "../../../../Service/service";
import { handlbars, HandlBars } from "../EmailInvatation/Components/handlbars";
import Handlebars, { log } from "handlebars";
import ScheduleEmail from "../EmailInvatation/Components/ScheduleEmail";
import { connect } from "react-redux";
import moment from "moment";
import { Link, Redirect } from "react-router-dom";
import {Text} from "Constants";
import { routeName } from "Service/env";
import { UpdateEventDetailsByUser } from "Actions/eventActions";
import ShowErrorToast from "../EmailInvatation/Components/ShowErrorToast";
import { Grammarly, GrammarlyEditorPlugin } from "@grammarly/editor-sdk-react";
import DatePicker from "react-modern-calendar-datepicker";
import TimePicker from "rc-time-picker";
import { history } from "../../../../store";


const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
      width: "100%",
      fontSize: 40,
      color: "red",
    },
  },
  feild: {
    fontSize: 40,
    color: "red",
  },
}));
const UpdateAttendees = ({
  eventUserEvents,
}) => {

  const [EditScheduleEmailData, setEditScheduleEmailData] = useState("");

  const [mainEventId, setMainEventId] = useState(
    eventUserEvents?.eventsAbout?.EventId
  );
  const [dataArray, setdataArray] = useState([]);

  const [isOpen, setIsOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [base64img, setBase64img] = useState("");
  const [baseImgUrl, setBaseImgUrl] = useState("");
  const [editorHtml1, setEditorHtml1] = useState("");
  const [UserId] = useState(localStorage.getItem("UserId"));
  const [newTime, setNewTime] = useState("");
  const [scheduleTimeType, setScheduleTimeType] = useState("Immediately");
  const [eventData, setEventData] = useState([]);
  const [organizer, setOrganizer] = useState("");

  const [scheduledEmailData, setScheduledEmailData] = useState([]);

  const [eventIds, setEventIds] = useState([]);
  const [isEdit, setIsEdit] = useState("");
  const [saveUpdateDetails, setSaveUpdateDetails] = useState(false);
  const [eventTitle, setEventTitle] = useState("");
  const [fromName, setfromName] = useState("");
  const [contactIds, setContactIds] = useState([]);
  const [imageError, setImageError] = useState({ show: false, message: "" });
  const [isEmailSend, setisEmailSend] = useState(false);
  const [scheduleTimeValue, setScheduleTimeValue] = useState("");
  const [eventDetailsByUser, setEventDetailsByUser] = useState("");
  const [limits, setLimits] = useState("");
  const [daysBefore, setDaysBefore] = useState("");
  const [eventDetails, setEventDetails] = useState("");

  const isRecurringStr = localStorage.getItem("isRecurring");
  const isRecurring = isRecurringStr === "true" ? true : false;

  useEffect(() => {
    const isEnabled =
        localStorage.getItem("IsEventUpdatesEnabled") === 'True';

    if (!isEnabled) {
      history.replace(`${routeName}/`);
    }
  }, []);


  const convertTimeUtcToLocal = (
    time,
    TimeZone = eventUserEvents?.eventsAbout?.TimeZone
  ) => {
    const UtcToLocal = moment.utc(time).local().format("MM/DD/YYYY hh:mm:ss A");
    var Time = moment(UtcToLocal, "MM/DD/YYYY hh:mm:ss A");

    const convertedTime = Time.tz(TimeZone);
    return moment(convertedTime);
  };

  const ConvertedStartDateTime = (Time) => {
    return `${moment(Time).format("MMM DD, YYYY")} at ${moment(Time).format(
      "hh:mm A"
    )}`;
  };

  const DefaultTextHeader = `
  <h2 style="font-size:30px !important; font-weight: 600; text-align:center; color: rgb(94, 94, 94);">Let's get together</h2>
  <p style="color: #888; text-align: center; font-family: Open Sans, Helvetica, Arial, sans-serif; font-size: 14px; font-weight: 500;">
    We're hosting a new event, and we'd love to see you there. Join us for ${
      eventDetails?.Title
    }, ${ConvertedStartDateTime(
    convertTimeUtcToLocal(eventDetails?.StartDateTime)
  )}
  </p>
  <p style="color: #888; text-align: center; font-family: Open Sans, Helvetica, Arial, sans-serif; font-size: 14px; font-weight: 500;">Register soon because space is limited.</p>
  <p style="color: #888; text-align: center; font-family: Open Sans, Helvetica, Arial, sans-serif; font-size: 14px; font-weight: 500;">We hope you're able to join us!</p>   
`;

  const html =
    EditScheduleEmailData !== ""
      ? EditScheduleEmailData?.Header
      : eventDetailsByUser !== ""
      ? eventDetailsByUser?.EmailHeader
      : DefaultTextHeader;
  const blocksFromHTML = convertFromHTML(html);
  const contentState = ContentState.createFromBlockArray(
    blocksFromHTML.contentBlocks,
    blocksFromHTML.entityMap
  );

  const [editorState, setEditorState] = useState(
    EditorState.createWithContent(contentState)
  );

  useEffect(() => {
    if (EditScheduleEmailData !== "") {
      setEditorState(EditorState.createWithContent(contentState));
    }
    if (eventDetails !== "") {
      setEditorState(EditorState.createWithContent(contentState));
    }
  }, [EditScheduleEmailData, eventDetails]);

  function toggleModal() {
    setIsOpen(!isOpen);
  }
  const classes = useStyles();

  const handleChange = (e, event) => {
    // setisChecked(e.target.checked);

    if (!dataArray.some(({ EventId }) => EventId === event.EventId)) {
      setdataArray([...dataArray, event]);
    } else {
      let freshArray = dataArray.filter(
        ({ EventId }) => EventId !== event.EventId
      );
      setdataArray([...freshArray]);
    }
  };

  useEffect(() => {
    axiosE
      .get(`GetAllPublishedEventsByOrganizer/${UserId}/0`)
      .then(({ data }) => {
        if (data.results.ResponseCode) {
          let AllPublishedEventsByUser = [...data.results.EventList];
          setEventData(
            AllPublishedEventsByUser.filter((e) => e.EventId !== mainEventId)
          );
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const styleMap = {
    STRIKETHROUGH: {
      textDecoration: "line-through",
    },
    textAlign: "center",
  };

  const getFileBase64 = (file, callback) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => callback(reader.result);
    // TODO: catch an error
    reader.onerror = (error) => {};
  };

  const imageUploadCallback = (file) => {
    return new Promise((resolve, reject) => {
      if (file.type === "image/gif") {
        reject("GIF uploads are not allowed");
        return;
      }

      getFileBase64(file, (data) =>
          resolve({ data: { link: data } })
      );
    });
  };

  const largeTextField = (title, editorState, onEditorStateChange) => {
    return (
      <React.Fragment>
        <GrammarlyEditorPlugin clientId="client_FdjdCy5cG4i2Wxi74peEG2">
          <div className="centered-editor">
            <Editor
              customStyleMap={styleMap}
              editorState={editorState}
              editorClassName="editor-class-about"
              toolbarClassName="toolbar-class-about"
              wrapperClassName="wrapper-class-about"
              onEditorStateChange={onEditorStateChange}
              handlePastedFiles={(files) => {
                if (files && files[0] && files[0].type === "image/gif") {
                  alert("GIFs are not allowed");
                  return true; // ❌ block
                }
                return false; // ✅ allow normal
              }}
              toolbar={{
                textAlign: { inDropdown: true },
                inline: { inDropdown: true },
                list: { inDropdown: true },
                link: { inDropdown: true },
                history: { inDropdown: true },
                image: {
                  previewImage: true,
                  urlEnabled: true,
                  uploadEnabled: false,
                  uploadCallback: (file) => imageUploadCallback(file),
                  inputAccept:
                    "image/jpeg,image/jpg,image/png,image/svg",
                  defaultSize: {
                    height: "auto",
                    width: "100%",
                  },
                },
              }}
              handlePastedText={() => imageUploadCallback()}
              // handlePastedText={() => false}
            />
          </div>
        </GrammarlyEditorPlugin>
      </React.Fragment>
    );
  };

  const replcaeEmptyTagwithBreakForEditor = (html) => {
    const newHtml = html
      ?.replaceAll("<p></p>", "<h6></h6>")
      .replaceAll("<h1></h1>", "<h6></h6>")
      .replaceAll("<h2></h2>", "<h6></h4>")
      .replaceAll("<h3></h3>", "<h6></h6>")
      .replaceAll("<h4></h4>", "<h6></h6>")
      .replaceAll("<h5></h5>", "<h6></h6>")
      .replaceAll("<h6></h6>", "<h6></h6>")
      .replaceAll("<pre></pre>", "<h6></h6>")
      .replaceAll("<blockquote></blockquote>", "<h6></h6>");

    return newHtml;
  };

  const onEditorStateChange = (editorState) => {
    const editorHtml = draftToHtml(
      convertToRaw(editorState.getCurrentContent())
    );

    setEditorHtml1(replcaeEmptyTagwithBreakForEditor(editorHtml));
    setEditorState(editorState);
  };

  // Add Constacts
  const [fileName, setFileName] = useState("");
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  // console.log("batchLimit", batchLimit);
  useEffect(() => {
    fetchData();
  }, []);

  const CheckIsLinkValid = (URL) => {
    if (URL) {
      return URL.substring(0, 8) === "https://" ||
        URL.substring(0, 7) === "http://"
        ? `${URL}`
        : `https://${URL}`;
    } else {
      return null;
    }
  };

  const replcaeEmptyTagwithBreak = (html) => {
    return html
      ?.replaceAll("<p></p>", "<br>")
      .replaceAll("<h1></h1>", "<br>")
      .replaceAll("<h2></h2>", "<br>")
      .replaceAll("<h3></h3>", "<br>")
      .replaceAll("<h4></h4>", "<br>")
      .replaceAll("<h5></h5>", "<br>")
      .replaceAll("<h6></h6>", "<br>")
      .replaceAll("<pre></pre>", "<br>")
      .replaceAll("<blockquote></blockquote>", "<br>");
  };
  const setBase64imgFn = (base64) => {
    // setBaseImgUrl("")
    setBase64img(base64);
  };

  const Data = {
    editorHtml1: replcaeEmptyTagwithBreak(editorHtml1),
    headerImg: baseImgUrl,
    data: dataArray.map((item) => {
      let emailInviteDataObj = Object.assign({}, item);
      emailInviteDataObj["RecurringTicket"] = item.RecurringTicket = item.RecurringTicket === "true" || item.RecurringTicket === true;
      emailInviteDataObj["StartDateTime"] = ConvertedStartDateTime(
        convertTimeUtcToLocal(item.StartDateTime)
      );
      return emailInviteDataObj;
    }),
    mainEventId,
    UserId,
    routeName,
    baseUrl: constants.URLs.baseUrl,
    hostName: constants.URLs.hostName,
    isRecurring
  };
  const template = Handlebars.compile(handlbars);
  const emailTemplate = template(Data);
  const GetAllEmailQueueInvitation = () => {
    axiosE
      .get(`GetAllEmailQueueInvitationByUserId/${UserId}`)
      .then(({ data }) => {
        if (data.results.ResponseCode) {
          setScheduledEmailData(data.results.ListInvitation);
        }
      })
      .catch((err) => console.log(err));
  };
  const updateEmailToPromote = async () => {
    const updateData = {
      EventId: mainEventId,
      Header: editorHtml1 === "" ? DefaultTextHeader : editorHtml1,
    };

    try {
      const { data } = await axiosE.post(
        "/Event/UpdateInvitationData",
        updateData
      );
      if (data.results.ResponseCode) {
        if (!isEdit) {
          setEventDetailsByUser(JSON.parse(data.results.Data));
          // dispatch(UpdateEventDetailsByUser(JSON.parse(data.results.Data)));
        }
        toggleModal();
        // handleSubmitEmail();
      }
    } catch (errorMessage) {}
  };

  const handleSubmitEmail = async () => {
    let EventIds = [];
    dataArray.map(({ EventId }) => {
      EventIds.push(EventId);
    });
    const payload = {
      UserId,
      Subject: eventTitle,
      FromName: fromName,
      MainEventId: mainEventId,
      EventIds: EventIds?.join(", "),
      SubscriberFileIds: contactIds.join(", "),
      ScheduleDateTime: newTime,
      Body: emailTemplate,
    };

    const { MainEventId, ...rest } = payload;

    if (isEdit) {
      try {
        const { data } = await axiosE.post(
          "/QueueEventInvitationEmail/Update",
          {
            ...rest,
            QueueId: isEdit,
          }
        );
        if (data.results.ResponseCode) {
          setIsEdit("");
          setSaveUpdateDetails(true);
          GetAllEmailQueueInvitation();
          setisEmailSend(true);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const { data } = await axiosE.post(
          "/QueueEventInvitationEmail/add",
          payload
        );

        if (data.results.ResponseCode) {
          GetAllEmailQueueInvitation();
          setSaveUpdateDetails(true);
          setisEmailSend(true);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const fetchData = async () => {
    const value = localStorage.getItem("mydata");
    if (value !== null) {
      setData(JSON.parse(value));
    }
  };

  useEffect(() => {
    if (isEdit && EditScheduleEmailData) {
      setEditorHtml1(EditScheduleEmailData?.Header);
      setEventTitle(EditScheduleEmailData?.Subject);
      // setEventDetails(dataArray[0]);
    }
  }, [EditScheduleEmailData]);
  // console.log("eventUserEvents?.eventsAbout", eventUserEvents);
  useEffect(() => {
    if (
      !dataArray.some(
        ({ EventId }) => EventId === eventUserEvents?.eventsAbout?.EventId
      )
    ) {
      setdataArray([...dataArray, eventUserEvents?.eventsAbout]);
    } else {
      setdataArray([...dataArray]);
    }
    // setdataArray([...dataArray, eventUserEvents?.eventsAbout]);
    setEventTitle(eventUserEvents?.eventsAbout?.Title);
    setOrganizer(
      eventDetailsByUser !== ""
        ? JSON.parse(eventDetailsByUser?.EmailFooter)?.Organizer
        : localStorage?.getItem("userFullName")
    );
    setfromName(
      fromName === "" ? localStorage?.getItem("userFullName") : fromName
    );
    // setOrganizer(localStorage?.getItem("userFullName"));
    GetAllEmailQueueInvitation();
    if (eventDetailsByUser !== "") {
      setEditorHtml1(
        eventDetailsByUser !== "" ? eventDetailsByUser?.EmailHeader : ""
      );
    }

    setEventDetails(eventUserEvents?.eventsAbout);
  }, [eventUserEvents, eventDetailsByUser]);

  // event tooltip fn
  if (imageError.show) {
    setTimeout(() => {
      hideError();
    }, 5000);
  }

  const showError = (message) => {
    setImageError({ show: true, message });
  };
  const hideError = () => {
    setImageError({ show: false, message: "" });
  };

  const CreateEventDetailsAboutToolTip = withStyles(() => ({
    tooltip: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 220,
      fontSize: "16px",
      border: "1px solid #dadde9",
    },
  }))(Tooltip);

  const titleWithToolTip = (title, tipText, mandatory = false) => {
    return (
      <span style={{ fontSize: 16, fontWeight: "bold", color: "#000000" }}>
        {title}
        {mandatory && <span style={{ color: "red" }}> *</span>}
        <CreateEventDetailsAboutToolTip
          title={<React.Fragment>{tipText}</React.Fragment>}
        >
          <span
            style={{
              padding: "0 0 0 10px",
              cursor: "pointer",
              color: "rgb(161, 3, 150)",
            }}
          >
            <Info />
          </span>
        </CreateEventDetailsAboutToolTip>
      </span>
    );
  };

  function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
    }, []);
    return size;
  }
  const [width, height] = useWindowSize();

  return (
    <div>
      {eventUserEvents.eventPublish ? null : (
        <Redirect to={`${routeName}/Dashboard/Publish`} />
      )}

      <div className="timeline_container">
        <div className="email_invite_wrapper">
          <ShowErrorToast message={error} closeToast={() => setError("")} />
          <div className="email_invite_header">
            <div className="email_invite">
              <span style={{ fontSize: 30 }}>
                {constants.Text.UpdateAttendee.UpdateAtendees}
              </span>
              {isEmailSend ? null : (
                <button onClick={toggleModal} className="email_invite_button">
                  {constants.Text.UpdateAttendee.AddUpdate}
                </button>
              )}
            </div>
          </div>
        </div>

        {isEmailSend ? (
          <div
            style={{
              height: "80vh",
              padding: 20,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <img src={Confetti} style={{ width: "100px", height: "auto" }} />
            <p style={{ color: "#808088", fontSize: 25, marginTop: 40 }}>
              {constants.Text.Congratulations}
            </p>
            <p
              style={{
                color: "#808088",
                fontSize: 25,
                marginTop: 10,
                textAlign: "center",
                lineHeight: "26px",
              }}
            >
              {scheduleTimeType === "Immediately"
                ? "Your email invite is on it's way."
                : "Your email invite is scheduled."}
            </p>
            <Button
              onClick={() => {
                setisEmailSend(false);
                // window.location.reload();
              }}
              style={{
                backgroundColor: "rgb(163, 56, 164)",
                fontSize: 14,
                marginTop: 25,
                height: 50,
                color: "#fff",
                padding: "12px 60px",
                border: "none",
                width: 320,
                borderRadius: 9,
                textTransform: "capitalize",
              }}
              className="btn_save_edit_details"
              // className={classes.eventDetailsAboutUploadMap}
              color={"primary"}
              variant={"contained"}
              component="span"
            >
              {constants.Text.SendAnotherInvite}
            </Button>
          </div>
        ) : (
          <div>
            <Modal
              open={isOpen}
              onClose={() => {
                toggleModal();
              }}
            >
              <div
                style={{
                  position: "relative",
                  float: "right",
                }}
              >
                <div
                  style={{
                    display: imageError.show ? "block" : "none",
                    position: "absolute",
                    top: 0,
                    right: "0",
                    zIndex: "2",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      background: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 30px",
                      background: "#d90d0d",
                      color: "white",
                      margin: "0px auto",
                      animationName: "slide-from-bottom",
                      animationDuration: "1s",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <ErrorOutlineIcon />
                      <p
                        style={{
                          margin: "0 0 0 20px",
                          textAlign: "start",
                        }}
                      >
                        {imageError.message}
                      </p>
                    </div>
                    <IconButton onClick={hideError}>
                      <CloseIcon
                        height={30}
                        width={30}
                        style={{ color: "white" }}
                      />
                    </IconButton>
                  </Box>
                </div>
                <div
                  className="edit_container_wrapper"
                  style={{ width: width < 600 ? width : 600 }}
                >
                  <div style={{ padding: 20 }}>
                    <div className="edit_container">
                      <div className="edit_container_close_btn">
                        <IoCloseOutline
                          size={20}
                          color="rgba(0, 0, 0, 0.54)"
                          onClick={toggleModal}
                        />
                      </div>
                      <p className="edit_container_header">
                        {constants.Text.UpdateAttendee.AddUpdate}
                      </p>
                      <div />
                    </div>
                  </div>
                  <div
                    className="edit_container_content"
                    style={{ position: "relative" }}
                  >
                    <p style={{ marginLeft: 10, fontSize: "16px" }}>
                      <b>{constants.Text.UpdateAttendee.headerText}</b>
                    </p>
                    <p style={{ marginLeft: 10 }}>
                      {constants.Text.UpdateAttendee.subtitleText}
                    </p>
                  </div>
                  {/* <hr style={{width:"80%",  backgroundColor: "rgba(0,0,0,0.9)", margin:0}} /> */}
                  <div className="edit_container_content">
                    <form autoComplete="off">
                      <div className="input_area">
                        <div class="label-float">
                          <input
                              style={{ backgroundColor: "transparent" }}
                              onChange={(e) => setfromName(e.target.value)}
                              // type="text"
                              placeholder=""
                              value={fromName}
                          />
                          <label>
                            {Text.From}<sup style={{ color: "red" }}>*</sup>
                          </label>
                        </div>
                      </div>

                      <div className="input_area">
                        <div class="label-float">
                          <input
                              style={{ backgroundColor: "transparent" }}
                              onChange={(e) => setEventTitle(e.target.value)}
                              // type="text"
                              placeholder=""
                              value=""
                          />
                          <label>
                            {Text.Subject}<sup style={{ color: "red" }}>*</sup>
                          </label>
                        </div>
                      </div>
                    </form>

                    {largeTextField(
                      "Event Description",
                      editorState,
                      onEditorStateChange
                    )}

                    <div className="timeline-content">
                      <h3>
                        {titleWithToolTip(
                            "When do you want to send it?",
                            "Choose whether or not you want to send your email out immediately or schedule it for later"
                        )}
                      </h3>
                      <ScheduleFor
                          limits={limits}
                          StartDateTime={convertTimeUtcToLocal(
                              dataArray[0]?.StartDateTime
                          )}
                          EndDatetime={convertTimeUtcToLocal(
                              dataArray[0]?.EndDateTime
                          )}
                          timezone={dataArray[0]?.TimeZone}
                          contactIds={contactIds}
                          daysBefore={daysBefore}
                          setDaysBefore={setDaysBefore}
                          updateEmailToPromote={handleSubmitEmail}
                          isEdit={isEdit}
                          newTime={newTime}
                          setNewTime={setNewTime}
                          scheduleTimeType={scheduleTimeType}
                          setScheduleTimeType={setScheduleTimeType}
                          handleSubmitEmail={handleSubmitEmail}
                          scheduleTimeValue={scheduleTimeValue}
                          setScheduleTimeValue={setScheduleTimeValue}
                          saveUpdateDetails={saveUpdateDetails}
                      />
                    </div>

                    <div className="detailAction" id="eventCommonModal">
                      <Button
                          onClick={toggleModal}
                          style={{
                            width: 120,
                            height: 50,
                            backgroundColor: "#fff",
                            fontSize: "1.5rem",
                            color: "#000000",
                            padding: "12px 60px",
                            borderColor: "#968e8e",
                          }}
                          className="btn_save_edit_details"
                          color={"primary"}
                          variant={"outlined"}
                          component="span"
                      >
                        {constants.Text.Cancel}
                      </Button>

                      <Button
                          disabled={
                            (scheduleTimeValue !== "" &&
                                scheduleTimeValue !== "daysbefore" &&
                                contactIds?.length > 0) ||
                            (scheduleTimeValue === "daysbefore" &&
                                daysBefore !== "" &&
                                contactIds?.length > 0)
                                ? false
                                : true
                          }
                          onClick={() => handleSubmitEmail()}
                          style={{
                            width: 120,
                            height: 50,
                            backgroundColor:
                                (scheduleTimeValue !== "" &&
                                    scheduleTimeValue !== "daysbefore" &&
                                    contactIds?.length > 0) ||
                                (scheduleTimeValue === "daysbefore" &&
                                    daysBefore !== "" &&
                                    contactIds?.length > 0)
                                    ? "#851679"
                                    : "#f7adff",
                            fontSize: "1.5rem",
                            color: "#fff",
                            padding: "12px 20px",
                            borderColor: "#968e8e",
                            textTransform: "capitalize",
                          }}

                          // style={{
                          //   backgroundColor:
                          //       (scheduleTimeValue !== "" &&
                          //           scheduleTimeValue !== "daysbefore" &&
                          //           contactIds?.length > 0) ||
                          //       (scheduleTimeValue === "daysbefore" &&
                          //           daysBefore !== "" &&
                          //           contactIds?.length > 0)
                          //           ? "#851679"
                          //           : "#f7adff",
                          //   fontSize: 14,
                          //   color: "#fff",
                          //   padding: "12px 20px",
                          //   borderRadius: 8,
                          //   textTransform: "capitalize",
                          // }}
                          color={"primary"}
                          variant={"contained"}
                          component="span"
                      >
                        <span style={{color: "#fff"}}>
                          {" "}
                          {scheduleTimeType === "Immediately" ? "Send now" : "Schedule"}
                        </span>
                      </Button>
                    </div>

                    {eventData?.length > 0 ? (
                      <div className="additionalEvent">
                        <h3 style={{ marginBottom: 20 }}>
                          {constants.Text.ChooseAdditionalInclude}
                        </h3>
                        {eventData?.map((event, i) => (
                          <div key={i} className="event_list_wrapper">
                            <div className="event_list">
                              <input
                                type="checkbox"
                                className="event_checkbox"
                                checked={dataArray.some(
                                  ({ EventId }) => EventId === event?.EventId
                                )}
                                onChange={(e) => handleChange(e, event)}
                              />

                              <div style={{ marginRight: 10, marginLeft: 20 }}>
                                <p
                                  style={{
                                    color: "#fc6603",
                                    fontWeight: "600",
                                    textAlign: "center",
                                  }}
                                  className="event_list_text"
                                >
                                  {moment(
                                    convertTimeUtcToLocal(
                                      event?.StartDateTime,
                                      event.TimeZone
                                    )
                                  )
                                    .format("MMM")
                                    .toLocaleUpperCase()}
                                </p>
                                <p
                                  style={{ textAlign: "center" }}
                                  className="event_list_text"
                                >
                                  {moment(
                                    convertTimeUtcToLocal(
                                      event?.StartDateTime,
                                      event.TimeZone
                                    )
                                  ).format("DD")}
                                </p>
                              </div>

                              <img
                                className="event_list_img"
                                src={event?.ImageMedium}
                                alt="event"
                              />
                            </div>
                            <div style={{ padding: 10 }}>
                              <p className="event_list_text_header">
                                {event?.Title}
                              </p>
                              <p className="event_list_text">
                                {event?.VenueName}
                              </p>
                              <p className="event_list_text">
                                {moment(
                                  convertTimeUtcToLocal(
                                    event?.StartDateTime,
                                    event.TimeZone
                                  )
                                ).format("MMM DD YYYY, hh:mm A")}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : null}

                  </div>
                </div>
              </div>
            </Modal>

            <div>
              <ScheduleEmail
                setEditorState={() =>
                  setEditorState(EditorState.createWithContent(contentState))
                }
                setMainEventId={setMainEventId}
                setEventTitle={setEventTitle}
                setFiles={setFiles}
                setIsEdit={setIsEdit}
                setdataArray={(data) => {
                  setdataArray(data);
                }}
                scheduledEmailData={scheduledEmailData}
                setScheduledEmailData={setScheduledEmailData}
                setEditScheduleEmailData={(data) => {
                  setBaseImgUrl("");
                  setBase64img("");
                  setEventDetails({
                    Title: data.Subject,
                    StartDateTime: data.ScheduleDateTime,
                  });
                  setEditScheduleEmailData(data);
                }}
              />
            </div>

          </div>
        )}

        {isEmailSend ? null : (
          <div className="save_and_continue">
            <div className="send_email_invite_btn2">
              {Number(limits.TotalCurrentMonthEmailSent) >=
              Number(limits.MonthlySendingEmailQuota) ? (
                <div className="limit_exceeds">
                  <p>
                    {constants.Text.monthlyLimit}
                    <b>{constants.Text.PhoneNumber}</b>
                    {constants.Text.ToIncreaseYourLimit}
                  </p>
                </div>
              ) : (
                <Button
                  disabled={
                    (scheduleTimeValue !== "" &&
                      scheduleTimeValue !== "daysbefore" &&
                      contactIds?.length > 0) ||
                    (scheduleTimeValue === "daysbefore" &&
                      daysBefore !== "" &&
                      contactIds?.length > 0)
                      ? false
                      : true
                  }
                  onClick={() => handleSubmitEmail()}
                  style={{
                    marginTop: 20,
                    backgroundColor:
                      (scheduleTimeValue !== "" &&
                        scheduleTimeValue !== "daysbefore" &&
                        contactIds?.length > 0) ||
                      (scheduleTimeValue === "daysbefore" &&
                        daysBefore !== "" &&
                        contactIds?.length > 0)
                        ? "#851679"
                        : "#f7adff",
                    fontSize: 14,
                    color: "#fff",
                    padding: "12px 20px",
                    borderRadius: 8,
                    textTransform: "capitalize",
                  }}
                  color={"primary"}
                  variant={"contained"}
                  component="span"
                >
                  <span style={{ color: "#fff" }}>
                    {" "}
                    {scheduleTimeType === "Immediately"
                      ? "Send now"
                      : "Schedule"}
                  </span>
                </Button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { eventUserEvents } = state;
  return {
    eventUserEvents: eventUserEvents,
    eventPublish: state.eventUserEvents.eventPublish,
  };
};

const matchDispatchToProps = (dispatch) => {
  return {
    UpdateEventDetailsByUser,
    dispatch,
  };
};

export default connect(mapStateToProps, matchDispatchToProps)(UpdateAttendees);
